import { parse, stringify } from "qs";
import { FC } from "react";
import { Link, useLocation } from "react-router-dom";
import { PaginationProps } from "utils/types/API";

interface AdminPaginationProps extends PaginationProps {
}

const AdminPagination: FC<AdminPaginationProps> = ({ page = 1, pageSize = 10, total = 0, pages, isFirst, isLast, totalPages }) => {
    const location = useLocation();

    if (totalPages <= 1) return null;

    const buildLink = (p: number) => {
        const qs = parse(location.search, { ignoreQueryPrefix: true });
        return {
            ...location,
            search: stringify({ ...qs, page: p, pageSize: qs.pageSize || 10 }, { arrayFormat: "brackets" })
        }
    };

    return (
        <div className="mt-6 flex justify-center">
            <nav className="flex items-center space-x-2 text-sm">
                <Link
                    to={buildLink(page - 1)}
                    className={`px-3 py-1.5 border rounded hover:bg-gray-100 ${isFirst ? "pointer-events-none text-gray-300 border-gray-200" : "border-gray-300 text-gray-500"}`}
                >
                    «
                </Link>
                {pages.map(p => {
                    if (p.active) {
                        return <span key={p.page} className="px-3 py-1.5 border rounded border-blue-600 text-blue-600 font-semibold">
                            {p.text}
                        </span>
                    }
                    else {
                        return <Link
                            key={p.page}
                            to={buildLink(p.page)}
                            className={`px-3 py-1.5 border rounded border-gray-300 text-gray-700 hover:bg-gray-100`}
                        >
                            {p.text}
                        </Link>
                    }
                })}
                <Link
                    to={buildLink(page + 1)}
                    className={`px-3 py-1.5 border rounded hover:bg-gray-100 ${isLast ? "pointer-events-none text-gray-300 border-gray-200" : "border-gray-300 text-gray-500"}`}
                >
                    »
                </Link>
            </nav>
        </div>
    );
};

export default AdminPagination;
